const state = {
  deviceType: window.innerWidth <= 768 ? 'mobile' : 'pc',
};
const mutations= {
  setDeviceType(state, type) {
    state.deviceType = type;
  }
}
const actions= {
  updateDeviceType({ commit }, customType) {
    const type = customType || (window.innerWidth <= 768 ? 'mobile' : 'pc');
    commit('setDeviceType', type);
  }
};

export default {
  state,
  mutations,
  actions
};
